import React from 'react';
import { roundTo3Decimal} from '../../../../../../Utils';

const TotalRow = ({ days, data }) => {
    const style = { fontSize: '18px', fontWeight: 'bold' };
    const valuesTd = days.reduce((arr, day) => {
        const dayData = data[day];

        arr.push(<td style={style} key={`${day}_spends`}>{roundTo3Decimal(dayData.spends)}</td>);
        arr.push(<td style={style} key={`${day}_conversions`}>{dayData.conversions}</td>);
        arr.push(<td style={style} key={`${day}_eCost`}>{roundTo3Decimal(dayData.eCost)}</td>);

        return arr;
    }, []);

    return (
        <tr>
            <td colSpan={2}>Total</td>
            {valuesTd}
        </tr>
    );
};

export default TotalRow;



// WEBPACK FOOTER //
// ./src/scenes/BidderECostCountry/components/DaysTable/components/TotalRow/index.js